import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ActivatedRoute } from '@angular/router';
import { ButtonComponent } from '../../button/button.component';
import { QueryParamsService } from '../../../../core/query-params.service';
import { CustomerFrontendManagementService } from '../../../../core/customer-frontend-management.service';

@Component({
  selector: 'app-keycloak-user-management-filter',
  standalone: true,
  imports: [CommonModule, FormsModule, IconFieldModule, InputIconModule, InputTextModule, DropdownModule, ButtonComponent],
  templateUrl: './keycloak-user-management-filter.component.html',
  styleUrl: './keycloak-user-management-filter.component.scss',
})
export class KeycloakUserManagementFilterComponent implements OnInit {
  @Output() filterListEvent = new EventEmitter<HttpParams>();

  firstName = '';
  lastName = '';
  selectedCustomerId: string | null = null;
  customerOptions: { label: string; value: string }[] = [];
  showClearButton = false;

  constructor(
    private queryService: QueryParamsService,
    private route: ActivatedRoute,
    private cfmService: CustomerFrontendManagementService
  ) {}

  ngOnInit(): void {
    this.loadFilterFromQueryParams();
    this.updateShowClearButton();
    this.loadCustomers();
  }

  filter(): void {
    const filterParams: Record<string, any> = this.buildFilterObject();
    filterParams['page'] = 0;
    const httpParams = this.queryService.createHttpParams(filterParams);
    this.filterListEvent.emit(httpParams);
  }

  clearFilter(): void {
    this.firstName = '';
    this.lastName = '';
    this.selectedCustomerId = null;

    const current = this.queryService.getCurrentQueryParams();
    const httpParams = this.queryService.createHttpParams({
      page: 0,
      size: current.get('size'),
    });
    this.filterListEvent.emit(httpParams);
    this.showClearButton = false;
  }

  onAnyChange(): void {
    this.updateShowClearButton();
  }

  private buildFilterObject(): Record<string, any> {
    const current = this.queryService.getCurrentQueryParams();
    const params: Record<string, any> = {};
    const size = current.get('size');
    if (size) params['size'] = size;
    if (this.firstName) params['firstName'] = this.firstName;
    if (this.lastName) params['lastName'] = this.lastName;
    if (this.selectedCustomerId) params['customerId'] = this.selectedCustomerId;
    return params;
  }

  private loadFilterFromQueryParams(): void {
    this.route.queryParams.subscribe((params) => {
      const http = this.queryService.convertQueryParamsToHttpParams(params);
      this.firstName = http.get('firstName') || '';
      this.lastName = http.get('lastName') || '';
      this.selectedCustomerId = http.get('customerId') || null;
    });
  }

  private updateShowClearButton(): void {
    this.showClearButton = !!(this.firstName || this.lastName || this.selectedCustomerId);
  }

  private loadCustomers(): void {
    this.cfmService.getAllCustomers().subscribe({
      next: (customers) => {
        this.customerOptions = (customers || []).map((c) => ({
          value: c.id,
          label: c.name,
        }));
      },
    });
  }
}
